const d = "https://i.mazey.net/feperf";

export const monitotAPI = {
  perfDay: `${d}/monitor/perf/day`,
  topics: `${d}/monitor/get/topic`,
  addTopic: `${d}/monitor/add/topic`,
};
